import styled from 'styled-components';
import { variant } from 'styled-system';
import { ColorProps, PropsWithPseudo } from '../../../theme/styledProps';

export const WEB_FIRST_COLUMN_WIDTH = `max(20vw, 285px)`;
export const MOBILE_FIRST_COLUMN_WIDTH = `max(40vw, 200px)`;

type PerformanceTableRowVariant = 'default' | 'clickable' | 'disabled';

export const PerformanceTableRow = styled.tr<{
  isExpanded?: boolean;
  isEmbeddedMobile?: boolean;
  variant?: PerformanceTableRowVariant;
  hasFixed?: boolean;
}>(
  ({ onClick }) => ({
    ...(onClick
      ? {
          userSelect: 'none',
          tabIndex: 0,
          role: 'button',
          outline: 'none',
          cursor: 'pointer',
        }
      : {}),
  }),
  ({ theme, hasFixed }) => ({
    ...(!hasFixed
      ? {
          'td:first-child': {
            width: WEB_FIRST_COLUMN_WIDTH,
            minWidth: WEB_FIRST_COLUMN_WIDTH,
            maxWidth: WEB_FIRST_COLUMN_WIDTH,
            [`@media only screen and (max-width: ${theme.breakpoints[0]})`]: {
              width: MOBILE_FIRST_COLUMN_WIDTH,
              minWidth: MOBILE_FIRST_COLUMN_WIDTH,
              maxWidth: MOBILE_FIRST_COLUMN_WIDTH,
            },
          },
        }
      : {}),
  }),
  ({ isExpanded, isEmbeddedMobile }) =>
    variant<PropsWithPseudo<ColorProps, '&:hover'>, PerformanceTableRowVariant>({
      variants: {
        default: {
          bg: 'bg',

          '&:hover': {
            bg: isEmbeddedMobile ? undefined : 'neutral.100',
          },
        },

        clickable: {
          bg: isExpanded ? 'primary.100' : 'bg',

          '&:hover': {
            bg: isEmbeddedMobile ? undefined : isExpanded ? 'primary.200' : 'neutral.100',
          },
        },

        disabled: {
          bg: 'neutral.50',
        },
      },
    }),
);

PerformanceTableRow.defaultProps = {
  isExpanded: false,
  variant: 'default',
};
